import { z } from 'zod';
import { UserCustomTalentAlertsConst } from '@axiom/const';
import { ZodArrayToEnum } from '@axiom/types';

import { UserSearchSchema } from './user-search';

export const UserFixedAlertsSchema = z.object({
  beachWithExperienceAlertActive: z.boolean(),
  clientCreatedAccountAlertActive: z.boolean(),
  clientCreatedOppAlertActive: z.boolean(),
  clientReqInterviewAlertActive: z.boolean(),
  clientSearchedInAfcAlertActive: z.boolean(),
  clientSignedInAlertActive: z.boolean(),
  talentSelectedOnOppAlertActive: z.boolean(),
  waitlistWithExperienceAlertActive: z.boolean(),
});

export type UserFixedAlerts = z.infer<typeof UserFixedAlertsSchema>;

export const UserCustomTalentAlertSchema = z.object({
  id: z.string().uuid(),
  candidateId: z.string().uuid(),
  alertType: z.enum(
    ZodArrayToEnum(Object.values(UserCustomTalentAlertsConst.AlertType))
  ),
  alertActive: z.boolean(),
  minAvailability: z.number().int().nonnegative().nullable(),
  candidateName: z.string(),
});

export type UserCustomTalentAlert = z.infer<typeof UserCustomTalentAlertSchema>;

export const UserCustomTalentAlertCreateSchema =
  UserCustomTalentAlertSchema.omit({ id: true, candidateName: true });

export type UserCustomTalentAlertCreate = z.infer<
  typeof UserCustomTalentAlertCreateSchema
>;

export const UserCustomTalentAlertUpdateSchema =
  UserCustomTalentAlertSchema.omit({ id: true, candidateName: true });

export type UserCustomTalentAlertUpdate = z.infer<
  typeof UserCustomTalentAlertUpdateSchema
>;

export const UserSavedSearchAlertSchema = UserSearchSchema.pick({
  alertActive: true,
  id: true,
  name: true,
});

export type UserSavedSearchAlert = z.infer<typeof UserSavedSearchAlertSchema>;

export const UserCustomAlertsSchema = z.object({
  savedSearchAlerts: z.array(UserSavedSearchAlertSchema),
  talentAlerts: z.array(UserCustomTalentAlertSchema),
});

export type UserCustomAlerts = z.infer<typeof UserCustomAlertsSchema>;

export const UserAlertsSchema = z.object({
  fixedAlerts: UserFixedAlertsSchema,
  customAlerts: UserCustomAlertsSchema,
});

export type UserAlerts = z.infer<typeof UserAlertsSchema>;
